import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ImprestApplicationForm from "./form";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = HRService.uri;
const actions = {
  entity: "Imprest Applications",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  dataObject: {
    objectName: "imprestApplicationsByUser",
    parameters: "",
  },
  showStatus: true,
};
function ImprestApplicationsByUserTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="Imprest Apllications"
          subtitle="View all your Imprest Apllications, create or update it"
          columns={imprestApplicationsColumns}
          FormComponent={ImprestApplicationForm}
          query={imprestApplicationsByUser}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default ImprestApplicationsByUserTable;
